// KPI Period Reducer

import * as actionTypes from './redux.actionTypes';
import { DEFAULT_PAGINATION } from './common';

const initialState = {
  periods: [],
  selectedPeriod: null,
  loading: false,
  error: null,
  filters: {
    search: '',
  },
  pagination: {
    limit: DEFAULT_PAGINATION.limit,
    offset: DEFAULT_PAGINATION.offset,
    totalItems: 0,
    totalPages: 0,
  },
};

const kpiPeriodReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Periods
    case actionTypes.FETCH_PERIODS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.FETCH_PERIODS_SUCCESS:
      return {
        ...state,
        loading: false,
        periods: action.payload.data || [],
        pagination: {
          ...state.pagination,
          totalItems: action.payload.pagination?.totalItems || 0,
          totalPages: action.payload.pagination?.totalPages || 0,
        },
      };

    case actionTypes.FETCH_PERIODS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch Period by ID
    case actionTypes.FETCH_PERIOD_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.FETCH_PERIOD_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedPeriod: action.payload.data || action.payload,
      };

    case actionTypes.FETCH_PERIOD_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Create Period
    case actionTypes.CREATE_PERIOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.CREATE_PERIOD_SUCCESS:
      return {
        ...state,
        loading: false,
        periods: [action.payload.data || action.payload, ...state.periods],
      };

    case actionTypes.CREATE_PERIOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Update Period
    case actionTypes.UPDATE_PERIOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.UPDATE_PERIOD_SUCCESS:
      const updatedPeriod = action.payload.data || action.payload;
      return {
        ...state,
        loading: false,
        periods: state.periods.map((period) =>
          period.id === updatedPeriod.id ? updatedPeriod : period
        ),
        selectedPeriod:
          state.selectedPeriod?.id === updatedPeriod.id
            ? updatedPeriod
            : state.selectedPeriod,
      };

    case actionTypes.UPDATE_PERIOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Delete Period
    case actionTypes.DELETE_PERIOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.DELETE_PERIOD_SUCCESS:
      return {
        ...state,
        loading: false,
        periods: state.periods.filter((period) => period.id !== action.payload),
      };

    case actionTypes.DELETE_PERIOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Set Filters
    case actionTypes.SET_PERIOD_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    // Set Pagination
    case actionTypes.SET_PERIOD_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload,
        },
      };

    // Reset State
    case actionTypes.RESET_PERIOD_STATE:
      return initialState;

    default:
      return state;
  }
};

export default kpiPeriodReducer;
